/**
 * @fileoverview Calorie data source and type definitions.
 */

import { CalorieSchema, type Calorie } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAuditFields, createDateField, createIdField, createJsonField, createStringField, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Calorie };

export const calorieDataSource = createBaseDataSource<Calorie>({
  endpoint: 'calorie',
  searchField: 'recorded_date',
  schema: CalorieSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createDateField('recorded_date', 'Recorded Date', FIELD_WIDTHS.XLARGE),
    {
      field: 'calories',
      headerName: 'Calories (kcal)',
      type: 'number',
      width: FIELD_WIDTHS.SMALL,
      editable: true,
    },
    createStringField('description', 'Description', FIELD_WIDTHS.XLARGE),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAuditFields(),
  ],
});

export const calorieCache = getCache('calorie');
